import {SupportedLocales} from '#types/locale.js';

export const externalStorageLanguage = {
  [SupportedLocales.EN]: {
    title: 'External Storage',
    description:
      "Set up a storage bucket for your exports for added security. GrowthLoop will send every export to your file store prior to it being sent to a destination. If this is not setup, we will use GrowthLoop's default secure bucket.",
    storagePlatform: {
      label: 'Storage Platform',
      aws: 'AWS',
      googleCloud: 'Google Cloud',
      azure: 'Microsoft Azure',
    },
    requiredFields: {
      title: 'Required fields',
      description:
        'The following details are required for GrowthLoop to access your storage bucket.',
    },
    fields: {
      s3Bucket: 'S3 Bucket',
      gcsBucket: 'GCS Bucket',
      azureContainer: 'Azure Blob Container',
      bucketPlaceholder: 'Bucket Name',
      bucketRegion: 'Bucket region',
      regionPlaceholder: 'Bucket region',
      serviceAccountFile: 'Service Account JSON File',
      azureStorageAccountName: 'Storage Account Name',
      azureStorageAccountNamePlaceholder: 'Storage Account Name',
      azureStorageAccessKey: 'Storage Access Key',
      azureStorageAccessKeyPlaceholder: 'Storage Access Key',
    },
    errors: {
      bucket: 'Bucket name is required',
      storagePlatform: 'Storage platform is required',
      regionName: 'Region is required for AWS',
      awsType: 'AWS authentication type is required',
      awsAccessKeyId: 'AWS access key ID is required',
      awsSecretAccessKey: 'AWS secret access key is required',
      roleArn: 'IAM role ARN is required',
      attachment: 'Service account file must be a JSON file',
      azureStorageAccountName: 'Azure storage account name is required',
      azureStorageAccessKey: 'Azure storage access key is required',
    },
    additionalSetup: {
      title: 'Additional setup details',
      description:
        'GrowthLoop can connect to your bucket through 2 different mechanisms.\nPlease set up the details for your appropriate setup.',
    },
    authenticationType: {
      label: 'Authentication Type',
      crossAccount: 'Cross account',
      secretKey: 'Secret Key',
    },
    secretKey: {
      description: 'Access through shared Secret and Access Key.',
      accessKey: 'Access Key',
      accessKeyPlaceholder: 'Access Key',
      accessSecret: 'Access Secret',
      accessSecretPlaceholder: 'Access Secret',
    },
    crossAccount: {
      roleBasedAccessLink: 'Role based access',
      iamRole: 'IAM Role',
      iamRolePlaceholder: 'IAM Role',
    },
    actions: {
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
      remove: 'Remove Storage',
      removed: 'External storage removed',
      created: 'External storage created',
    },
    storageActive: 'storage active',
    storageActiveTooltip:
      'External storage cannot be edited. Remove it to make changes.',
  },
  [SupportedLocales.ES]: {
    title: 'Almacenamiento Externo',
    description:
      'Configure un bucket de almacenamiento para sus exportaciones para mayor seguridad. GrowthLoop enviará cada exportación a su almacén de archivos antes de enviarlo a un destino. Si no está configurado, usaremos el bucket seguro predeterminado de GrowthLoop.',
    storagePlatform: {
      label: 'Plataforma de Almacenamiento',
      aws: 'AWS',
      googleCloud: 'Google Cloud',
      azure: 'Microsoft Azure',
    },
    requiredFields: {
      title: 'Campos requeridos',
      description:
        'Los siguientes detalles son necesarios para que GrowthLoop acceda a su bucket de almacenamiento.',
    },
    fields: {
      s3Bucket: 'Bucket S3',
      gcsBucket: 'Bucket GCS',
      azureContainer: 'Contenedor de Azure Blob',
      bucketPlaceholder: 'Nombre del Bucket',
      bucketRegion: 'Región del bucket',
      regionPlaceholder: 'Región del bucket',
      serviceAccountFile: 'Archivo JSON de Cuenta de Servicio',
      azureStorageAccountName: 'Nombre de la Cuenta de Almacenamiento',
      azureStorageAccountNamePlaceholder:
        'Nombre de la Cuenta de Almacenamiento',
      azureStorageAccessKey: 'Clave de Acceso de Almacenamiento',
      azureStorageAccessKeyPlaceholder: 'Clave de Acceso de Almacenamiento',
    },
    errors: {
      bucket: 'El nombre del bucket es requerido',
      storagePlatform: 'La plataforma de almacenamiento es requerida',
      regionName: 'La región es requerida para AWS',
      awsType: 'El tipo de autenticación de AWS es requerido',
      awsAccessKeyId: 'La clave de acceso de AWS es requerida',
      awsSecretAccessKey: 'El secreto de acceso de AWS es requerido',
      roleArn: 'El rol IAM es requerido',
      attachment: 'El archivo de cuenta de servicio debe ser un archivo JSON',
      azureStorageAccountName:
        'El nombre de la cuenta de almacenamiento de Azure es requerido',
      azureStorageAccessKey:
        'La clave de acceso de almacenamiento de Azure es requerida',
    },
    additionalSetup: {
      title: 'Detalles de configuración adicionales',
      description:
        'GrowthLoop puede conectarse a su bucket a través de 2 mecanismos diferentes.\nPor favor, configure los detalles para su configuración apropiada.',
    },
    authenticationType: {
      label: 'Tipo de Autenticación',
      crossAccount: 'Cuenta cruzada',
      secretKey: 'Clave Secreta',
    },
    secretKey: {
      description:
        'Acceso a través de Clave Secreta y Clave de Acceso compartidas.',
      accessKey: 'Clave de Acceso',
      accessKeyPlaceholder: 'Clave de Acceso',
      accessSecret: 'Secreto de Acceso',
      accessSecretPlaceholder: 'Secreto de Acceso',
    },
    crossAccount: {
      roleBasedAccessLink: 'Acceso basado en roles',
      iamRole: 'Rol IAM',
      iamRolePlaceholder: 'Rol IAM',
    },
    actions: {
      cancel: 'Cancelar',
      save: 'Guardar',
      saving: 'Guardando...',
      remove: 'Eliminar Almacenamiento',
      removed: 'Almacenamiento externo eliminado',
      created: 'Almacenamiento externo creado',
    },
    storageActive: 'almacenamiento activo',
    storageActiveTooltip:
      'El almacenamiento externo no puede ser editado. Elimínalo para hacer cambios.',
  },
};
